'use strict';

class ParticipantMove {
  constructor($location, $routeParams, eventService, validationService, Notification) {
    this.$location = $location;
    this.eventService = eventService;
    this.validationService = validationService;
    this.Notification = Notification;

    this.number = $routeParams.number;
    this.participantNumber = $routeParams.participantNumber;
  }

  $onInit() {
    this.q = null;
    this.originalEvent = {};
    this.events = {};
    this.event = {};
    this.participant = {};

    this.eventService.getEvent(this.number)
      .then((resp) => {
        this.originalEvent = resp.data;
      });

    this.eventService.getParticipant(this.number, this.participantNumber)
      .then((resp) => {
        this.participant = resp.data;
      });

    this.search();
  }

  search() {
    this.eventService.getEvents(this.q)
      .then((resp) => {
        this.events = resp.data;
      });
  }

  select(number) {
    this.eventService.getEvent(number)
      .then((resp) => {
        this.event = resp.data;
      });
  }

  move() {
    this.event.customFields.forEach((item) => {
      if (item.type === 'DATE') {
        if (item.value) {
          item.value = moment(item.value, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }
      }
      return item;
    });

    if (this.event.number) {
      this.eventService.move(this.number, this.participantNumber,
        {
          eventNumber: this.event.number,
          customFields: this.event.customFields
        })
        .then(() => this.$location.path(`/vert/${this.event.number}/deltagere`))
        .catch((err) => {
          this.validationService.cleanupErrors();
          this.validationService.listErrors(err.data.errors);
        });
    } else {
      this.Notification.error('Du må velge et arrangement først');
    }
  }
}

ParticipantMove.$inject = ['$location', '$routeParams', 'eventService', 'validationService', 'Notification'];

const participantMove = {
  controller: ParticipantMove,
  templateUrl: 'event/move.html'
};

angular
  .module('SendRegning')
  .component('participantMove', participantMove)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/deltagere/:participantNumber/flytt', {
        title: 'Flytt deltager',
        template: '<participant-move />',
        secure: true
      });
  });
